import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import InputType from '../InputType';
import Button from '../../../atomic/Buttons/Button';

//Components

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  font-size: 16px;
`

const ButtonStyled = styled(Button)`
  margin: auto;
  max-width: 225px;
`

const AlertButton = styled(Button)`
  margin: auto;
  max-width: 225px;
  background-color: #f50057;
  color: white;
`
const Alert = styled(Icon)`
	// font-size: 36px;
  margin-right: 4px;
  color: white;
`

const ButtonPrompt = ({
  text,
  onPrompt,
  invalid,
  children,
  ...other
}) => {

  const getButtonStatus = () => {
    return invalid ? (
      <AlertButton variant="contained" onClick={onPrompt}>
        <Alert>error</Alert>
        {text}
      </AlertButton>
    ) : ( 
      <ButtonStyled variant="contained" onClick={onPrompt}>
        {text}
      </ButtonStyled>
    )
  }

  return (
    <InputType {...other}>
      {
        onPrompt ? getButtonStatus() : (
          <TextContainer>{text}</TextContainer>
        )
      }
    </InputType>
  )
}

ButtonPrompt.propTypes = {
  text: PropTypes.string,
  onPrompt: PropTypes.func,
  invalid: PropTypes.bool,
};

ButtonPrompt.defaultProps = {
  invalid: false
};

export default ButtonPrompt;
